// import swiper
// import Swiper from 'swiper/bundle';
// import 'swiper/css/bundle';


// initialize feature slider
var swiper = new Swiper(".slider-feature", {
    allowTouchMove: false,
    slidesPerView: "auto",
    spaceBetween: 10,
    navigation: {
        prevEl: ".slider-prev",
        nextEl: ".slider-next",
    },
});
